import { ConfigIO } from 'ui-io/config-io';
import fetchApi from '../fetch-api'

type CompanyByIdPropsT = {
  companyID: string|undefined
}

export const getCompanyConfig = (props: CompanyByIdPropsT) => {
  const { companyID } = props
  return {
    queryKey: [companyID],
    queryFn: () =>
      fetchApi({
        service: 'admin-service',
        headers:{method: 'GET'},
        pathname: `/get-configuration?companyID=${companyID}`,
        codec: ConfigIO,
      }),
  }
}
